import React from 'react';
interface TeachingFlowProps {
  steps: string[];
  size?: 'sm' | 'lg';
  tone?: 'dark' | 'light';
  className?: string;
}
export function TeachingFlow({
  steps,
  size = 'sm',
  tone = 'dark',
  className = ''
}: TeachingFlowProps) {
  const sizeClass = size === 'lg' ? 'gap-x-3 text-[15px] font-bold tracking-[0.14em] sm:gap-x-4 sm:text-[20px]' : 'gap-x-3 text-[11px] font-semibold tracking-[0.18em]';
  const textClass = tone === 'light' ? 'text-white' : size === 'lg' ? 'text-brand-plum' : 'text-brand-charcoal/65';
  const arrowClass = tone === 'light' ? 'text-brand-lilac' : 'text-brand-gold';
  return <p className={`flex flex-wrap items-center justify-center gap-y-2 font-body uppercase ${sizeClass} ${textClass} ${className}`} data-id="element-211" data-mp="69epdpk1ftdm">
      {steps.map((step, index) => <React.Fragment key={step} data-id="element-212" data-mp="281knsdvyeu9v" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={arrowClass} data-id="element-213" data-mp="283x5cpxsv2me">
              →
            </span>}
          <span data-id="element-214" data-mp="2352o3sfhdm4e">{step}</span>
        </React.Fragment>)}
    </p>;
}